module.exports = __webpack_public_path__ + "img/vue-01-13.0445baf1.png";